
import { JOBS_URL, getJobExcerpt, getJobUrl } from '@/utils/jobs'
import themeMixin from '~/mixins/theme'

export default {
  mixins: [themeMixin],
  props: {
    id: {
      type: Number,
      required: true,
      default: () => {},
    },
    isPromoted: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isLoading: true,
      error: false,
      job: {},
    }
  },
  async fetch() {
    const job = await this.getJobById(this.id)

    this.job = job
  },
  computed: {
    excerpt() {
      return getJobExcerpt(this.job)
    },
    jobUrl() {
      return getJobUrl(this.job)
    },
    themeComputedClass() {
      return this.getThemeClass(this.theme)
    },
  },
  methods: {
    async getJobById(jobId) {
      return await this.$axios.$get(`${JOBS_URL}/${jobId}`)
    },
  },
}
